<template>
  <div>
    <template v-if="false">
      tryCnt: <strong>{{ 3 - cnt }}</strong> <br/>
      cameraPermission: <strong>{{ cameraPermission }} </strong><br/>
      deviceInfoLength: <strong>{{ deviceInfoLength }}</strong><br/>
      cameraId: <strong>{{ cameraId }}</strong><br/>
      cameraLabel: <strong>{{ cameraLabelOne }}</strong><br/>
    </template>
    <select name="s_courier" id="s_courier" class="t-select" v-model="subCameraId" style="height: 30px; padding-left: 10px;">
      <option value="">QR인식이 안되면 카메라를 변경해서 다시 시도해주세요.</option>
      <option
        v-for="(cameraObj, index) in cameraList"
        :key="`cameraObj-${index}`"
        :value="cameraObj.camId">{{ cameraObj.camNm }}
      </option>
    </select>
    <div id="qrScanner" style="width: 100%" />
  </div>
</template>

<script>
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode'

export default {
  components: {

  },
  props: [ 'cameraPermission' ],
  data: () => ({
    decodeResult: {},
    decodeText: '',
    qrScanner: null,
    deviceInfoLength: 0,
    deviceInfo: [],
    cnt: 0,
    cameraId: '',
    subCameraId: '',
    succedCameras: [],
    cameraLabelOne: '',
    cameraList: []
  }),
  computed: {

  },
  created () {

  },
  async mounted () {
    this.init(0)
  },
  watch: {
    decodeText (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.$emit('readText', newVal)
      }
    },
    subCameraId (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.cameraId = newVal
        this.startScanCamera()
      }
    }
  },
  methods: {
    async init () {
      this.cameraId = await this.getCameraInfo()

      this.startScanCamera()
    },
    async startScanCamera () {
      if (this.cnt > 2 && !this.cameraId) {
        this.$Alert.alert('기기의 카메라를 사용할 수 없어요.')
        return
      }

      if (!this.cameraId) {
        this.cnt++
        setTimeout(() => {
          this.init(this.cnt)
        }, 1000)
        return
      }

      const formatsToSupport = [
        Html5QrcodeSupportedFormats.QR_CODE,
        Html5QrcodeSupportedFormats.AZTEC,
        Html5QrcodeSupportedFormats.CODABAR,
        Html5QrcodeSupportedFormats.CODE_39,
        Html5QrcodeSupportedFormats.CODE_93,
        Html5QrcodeSupportedFormats.CODE_128,
        Html5QrcodeSupportedFormats.DATA_MATRIX,
        Html5QrcodeSupportedFormats.MAXICODE,
        Html5QrcodeSupportedFormats.ITF,
        Html5QrcodeSupportedFormats.EAN_13,
        Html5QrcodeSupportedFormats.EAN_8,
        Html5QrcodeSupportedFormats.PDF_417,
        Html5QrcodeSupportedFormats.RSS_14,
        Html5QrcodeSupportedFormats.RSS_EXPANDED,
        Html5QrcodeSupportedFormats.UPC_A,
        Html5QrcodeSupportedFormats.UPC_E,
        Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION
      ]

      this.qrScanner = new Html5Qrcode(
        'qrScanner',
        {
          verbose: false,
          formatsToSupport,
          useBarCodeDetectorIfSupported: true
        }
      )

      const successCallback = (decodedText, decodedResult) => {
        // QR 코드 스캔 성공 시 처리
        this.decodeResult = decodedResult
        this.decodeText = decodedText
      }

      const errorCallback = (error) => {
        // QR 코드 스캔 실패 시 처리
        if (process.env.NODE_ENV !== 'production') {
          console.error(error)
        }
        // qrScanner.pause()
      }

      const configuration = {
        fps: 100,
        qrbox: { width: 400, height: 400 }
      }
      try {
        await this.qrScanner.start(this.cameraId, configuration, successCallback, errorCallback)
        this.succedCameras.unshift(this.cameraId)
      } catch (e) {
        this.$Alert.alert('기기의 카메라를 사용할 수 없어요.')
          .then(() => {
            if (this.succedCameras.length > 0) {
              this.subCameraId = this.succedCameras.pop()
            } else {
              location.reload()
            }
          })
      }

      this.cnt = 0
    },
    stopScanner () {
      console.log('qrScanner stop', this.qrScanner.getState())
      this.qrScanner.getState()
      this.qrScanner.stop()
        .then(() => {
          this.qrScanner.clear()
        })
      this.qrScanner.pause()
    },
    async getCameraInfo () {
      let res
      try {
        const devices = await navigator.mediaDevices.enumerateDevices()
        this.deviceInfoLength = devices.length
        this.deviceInfo = devices

        if (!this.deviceInfoLength) {
          this.cnt++
          setTimeout(() => {
            this.init(this.cnt)
          }, 1000)
          return
        }

        devices.forEach(device => {
          if (device.kind === 'videoinput') {
            this.cameraList.push({
              camId: device.deviceId,
              camNm: device.label
            })
            this.cameraLabelOne = device.label
            res = device.deviceId
          }
        })
      } catch (e) {
        console.error('미디어 장치를 사용할 수 없습니다.')
      }

      return res
    }
  }
}
</script>
<style>
.t-select-camlist {
  border: 1px solid #E3E3E3;
  width: 100%;
  height: 100%;
  position: relative;
  outline: 0;
  font-family: 'SCDream';
  font-weight: 300;
  font-size: 0.6875rem;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/BarcodSC.vue